import React, { useRef } from 'react';
import './FieldsShort.css';
import { Link } from 'react-router-dom';
import { SectionHeader, SectionWrap } from '../../Components';
import { FaPeopleArrows } from "react-icons/fa6";
import { CiCircleChevRight, CiCircleChevLeft } from "react-icons/ci";
import { MdMapsHomeWork } from "react-icons/md";
import { RiBuilding2Fill } from "react-icons/ri";
import { FaCopyright } from "react-icons/fa";
import { BsPersonVcardFill } from "react-icons/bs";
import { ImCalculator } from "react-icons/im";
import { useTranslation } from 'react-i18next';


function FieldsShort() {
  const itemsHolderRef = useRef(null);
  const { t, i18n } = useTranslation();
  

  const scrollLeft = () => {
    if (itemsHolderRef.current) {
      itemsHolderRef.current.scrollBy({ left: -340, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (itemsHolderRef.current) {
      itemsHolderRef.current.scrollBy({ left: 340, behavior: 'smooth' });
    }
  };

  return (
    <>
      <div className='ourFieledSection containerNew'>
        <SectionWrap>
          <SectionHeader title={t('fieldsTitle')} disc={t('fieldsPageSpan')} />
          <div className='scrollButtons'>
            <button onClick={scrollRight}><CiCircleChevRight /></button>
            <button onClick={scrollLeft}><CiCircleChevLeft /></button>
          </div>
          <div className='itemesHolder' ref={itemsHolderRef}>
            <div className='itemFieled'>
              <div className='headFieled'>
                <RiBuilding2Fill />
                <h4>{t('fieldsShort1')}</h4>
              </div>
              <div className='hiddingDisc'>
                <p>{t('fieldsShort1Disc')}</p>
                <Link to={'/firms'} target='_top'><CiCircleChevRight /></Link>
              </div>
            </div>
            <div className='itemFieled'>
              <div className='headFieled'>
                <MdMapsHomeWork />
                <h4>{t('fieldsShort2')}</h4>
              </div>
              <div className='hiddingDisc'>
                <p>{t('fieldsShort2Disc')}</p>
                <Link to={'/property'} target='_top'><CiCircleChevRight /></Link>
              </div>
            </div>
            <div className='itemFieled'>
              <div className='headFieled'>
                <FaPeopleArrows />
                <h4>{t('fieldsShort3')}</h4>
              </div>
              <div className='hiddingDisc'>
                <p>{t('fieldsShort3Disc')}</p>
                <Link to={'/conflict'} target='_top'><CiCircleChevRight /></Link>
              </div>
            </div>
            <div className='itemFieled'>
              <div className='headFieled'>
                <FaCopyright />
                <h4>{t('fieldsShort4')}</h4>
              </div>
              <div className='hiddingDisc'>
                <p>{t('fieldsShort4Disc')}</p>
                <Link to={'/copywrites'} target='_top'><CiCircleChevRight /></Link>
              </div>
            </div>
            <div className='itemFieled'>
              <div className='headFieled'>
                <BsPersonVcardFill />
                <h4>{t('fieldsShort5')}</h4>
              </div>
              <div className='hiddingDisc'>
                <p>{t('fieldsShort5Disc')}</p>
                <Link to={'/employee'} target='_top'><CiCircleChevRight /></Link>
              </div>
            </div>
            <div className='itemFieled'>
              <div className='headFieled'>
                <ImCalculator />
                <h4>{t('fieldsShort6')}</h4>
              </div>
              <div className='hiddingDisc'>
                <p>{t('fieldsShort6Disc')}</p>
                <Link to={'/taxes'} target='_top'><CiCircleChevRight /></Link>
              </div>
            </div>
          </div>
        </SectionWrap>
      </div>
    </>
  );
}

export default FieldsShort;